<template>
  <div class="intro">
    <div class="d-flex flex-column fill-height">
      <v-img
        src="../assets/login.png"
        class="intro__image"
        max-height="317"
        width="100%"
        position="center 80%"
        cover
      />
      <div class="intro__text">
        <h2 class="bold mb-6">{{ $t("login.description.title") }}</h2>
        <span class="body-1" v-html="$t('login.description.content')" />
      </div>
      <niko-button
        class="mt-4 align-self-start intro__learn-more"
        :text="$t('login.description.button.text')"
        :href="$t('login.description.button.url')"
        target="_blank"
        type="button"
      />
    </div>
  </div>
</template>

<script>
import NikoButton from "@/components/UI/NikoButton";

export default {
  name: "intro",
  components: {
    NikoButton,
  },
};
</script>

<style lang="scss">
.intro {
  background: #e5e5e5;
  padding: 0 0 64px;
  height: 100%;

  &__image {
    margin-bottom: 56px;
  }

  &__text {
    padding: 0 72px;
    color: #1a1a1a;
  }

  &__learn-more {
    margin-left: 72px;
    border-color: #999999;
    color: #4c4c4c !important;
  }
}
</style>
